import _ from "lodash";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { retrieveSearchSessionMetadata } from "../../api";
import { sendPixelEvent } from "../../helpers";

export function useSuccessfulBooking({
  product_type,
  page_session_id,
}: {
  product_type: string;
  page_session_id: string;
}) {
  const history = useHistory();

  useEffect(() => {
    retrieveSearchSessionMetadata({ page_session_id })
      .then((data) => {
        if (data.session_id !== page_session_id) history.push("/404");
      })
      .catch(() => history.push("/404"));
  }, [page_session_id, history]);

  useEffect(() => {
    sendPixelEvent("succesfulBooking", {
      data: { product_type },
      withInit: true,
    });
  }, []);
}

export function useBookingProcess() {
  const [step, setStep] = useState(0);
  const [loading, setLoading] = useState(true);

  const { payment_supplier, payment_type, withPoints, mixedPointsPayments } =
    useSelector(
      (state: {
        WebsiteMetadata: {
          metadata: {
            payment_supplier: string;
            payment_type: string;
            points_scheme: boolean;
            mixed_points_payments: boolean;
          };
        };
      }) => {
        const payment_supplier =
          state?.WebsiteMetadata?.metadata?.payment_supplier ?? "STR";
        const payment_type =
          state?.WebsiteMetadata?.metadata?.payment_type ?? "HOS";

        const withPoints =
          state.WebsiteMetadata?.metadata?.points_scheme ?? false;

        const mixedPointsPayments =
          state.WebsiteMetadata?.metadata?.mixed_points_payments ?? false;
        return {
          payment_supplier,
          payment_type,
          withPoints,
          mixedPointsPayments,
        };
      },
    );

  function onDecreaseStep() {
    setStep((p) => p - 1);
  }
  function onIncreaseStep() {
    setStep((p) => p + 1);
  }

  return {
    withPoints,
    mixedPointsPayments,
    loading,
    payment_supplier,
    payment_type,
    step,
    setStep,
    onIncreaseStep,
    onDecreaseStep,
    onLoading: () => setLoading(true),
    onIdle: () => setLoading(false),
  };
}
